import { create } from 'zustand';

export const useClassificationStore = create((set) => ({
  classificationItems: [],
  loading: false,
  error: null,
  success: null,

  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  searchParams: {
    searchTerm: '',
    sortBy: 'createdAt',
    sortDirection: 'desc'
  },
  columnFilters: {},
  uniqueValues: {},

  isFormOpen: false,
  isEditMode: false,
  deleteDialogOpen: false,
  selectedClassification: null,
  classificationToDelete: null,

  setClassificationItems: (items) => set({ classificationItems: items }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setSearchParams: (params) => set((state) => ({
    searchParams: { ...state.searchParams, ...params }
  })),
  setColumnFilters: (filters) => set({ columnFilters: filters }),

  openAddForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedClassification: null,
    error: null,
    success: null
  }),

  openEditForm: (item) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedClassification: item,
    error: null,
    success: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedClassification: null,
    error: null,
    success: null
  }),

  openDeleteDialog: (item) => set({
    deleteDialogOpen: true,
    classificationToDelete: item
  }),

  closeDeleteDialog: () => set({
    deleteDialogOpen: false,
    classificationToDelete: null
  }),

  clearError: () => set({ error: null }),
  clearSuccess: () => set({ success: null }),
}));
